/**
 * Input for JSONata expression evaluation
 */
export interface JSONataInput {
  /**
   * The data against which the expression will be evaluated
   */
  data: unknown;
  /**
   * The expression to be evaluated
   */
  expression: string;
}
